export const GA_JOB_APPLY_COOKIE_NAME = 'ga_job_apply';
export const MAX_DECODE_ITERATIONS = 3;

export const GA_JOB_APPLY_COOKIE_CONFIG = {
  maxAge: 60,
  path: '/',
  domain: process.env.NEXT_PUBLIC_LOCALE_COOKIE_DOMAIN,
};

/**
 * Builds the semicolon-separated string value for the ga_job_apply cookie.
 * Format: itemId;itemName;itemBrand;placement;itemListId[;conversionEventId]
 * The optional 6th part is the backend's conversion event id (transaction_id for Google Ads dedup).
 * ';' is stripped from every part (job titles, company names) so the parts never shift.
 */
export const buildGaApplyCookieValue = (
  itemId: string | number = '',
  itemName: string = '',
  itemBrand: string = '',
  placement: string = '',
  itemListId: string = '',
  conversionEventId: string = '',
) => [itemId, itemName, itemBrand, placement, itemListId, conversionEventId].map((part) => String(part).replace(/;/g, ',')).join(';');
